module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Bowl-d6c039a8559ec9e7bfb964523997adce.svg";